import React from 'react';
import {useTranslation} from 'react-i18next';
import { NavLink } from 'reactstrap';
//import $ from 'jquery';



const AccessRightSideMenu = (props) => {

    const {t} = useTranslation();
  //  const hasTree  = $('.has-treeview'),
 //   treeView = $('.nav-treeview');  
    ////$(hasTree).click(function(){
     ///  $(this).find('.has-treeview').slideToggle();
    //});

    const getRights = (blockName) => {
            props.parentCallback(blockName);
    }

    return (
                <div className="sidebar" style={{"cursor": "pointer"}}>          
                    <nav className="mt-2">
                        <ul
                            className="nav nav-pills nav-sidebar flex-column"
                            data-widget="treeview"
                            role="menu"
                            data-accordion="false"
                        >                         
                            <li className="nav-item has-treeview">
                               <NavLink>
                                    <i className="nav-icon fas fa-university" />
                                    <p>{t('menusidebar.label.company')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('users')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('user.label.users')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('departments')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('department.label.departments')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('overview')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('general.label.overview')}</p>                             
                                        </NavLink>
                                    </li>
                               </ul>
                            </li>
                            <li className="nav-item has-treeview">
                            <NavLink>
                                    <i className="nav-icon fa fa-users" />
                                    <p>{t('menusidebar.label.team')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul class="nav nav-treeview">
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('attendanceSelf')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('attendance.label.attendanceSelf')}</p>                             
                                        </NavLink>
                                    </li>                                   
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('attendanceOthers')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('attendance.label.attendanceOthers')}</p>                             
                                        </NavLink>
                                    </li>  
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('attendanceAdmin')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('attendance.label.attendanceAdmin')}</p>                             
                                        </NavLink>
                                    </li>  
                                    <li className="nav-item" style={{"marginLeft": "30px"}}>
                                        <NavLink onClick={() =>getRights('tasks')}>                                  
                                            <i className="fa fa-square fa-sm fa-fw" style={{"marginRight": "5px"}}></i>
                                            <p>{t('task.label.tasks')}</p>                             
                                        </NavLink>
                                    </li>                                     
                               </ul>
                            </li>                           
                        </ul>
                    </nav>
                </div>
    );

}

export default AccessRightSideMenu;
